export default function MySQL_LEFTJOIN() {
  return (
    <div>
      <h2>MySQL_LEFTJOIN</h2>    </div>
  );
}